document.addEventListener('DOMContentLoaded', function () {
  // Show/Hide header tabs
  var tabs = document.querySelectorAll('.tab-2');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      // Remove active class from all tab contents
      var tabContents = document.querySelectorAll('.tab-content-2');
      tabContents.forEach(function (content) {
        content.classList.remove('active-tab-content-2');
      });
      // Add active class to the selected tab content
      var dataId = tab.getAttribute('data-id');
      var selectedTabContent = document.querySelector('.tab-content-2[data-id="' + dataId + '"]');
      selectedTabContent.classList.add('active-tab-content-2');
      // Remove active class from all tabs
      tabs.forEach(function (t) {
        t.classList.remove('active-tab-2');
      });
      // Add active class to the clicked tab
      tab.parentNode.querySelector('.tab-2').classList.add('active-tab-2');
    });
  });
});

